export default "__VITE_ASSET__JrxZ2elA__"